import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2498 3.1331L16.9309 4.5988C15.6756 4.32567 14.2483 4.5999 12.9532 5.66585L12 6.45037L11.0467 5.66585C9.75159 4.5999 8.32435 4.32567 7.06904 4.59881L7.06903 4.59882C5.66658 4.90397 4.4563 5.89771 3.8751 7.31199C2.77243 9.99517 3.83144 14.8091 12.0001 19.3951C20.1686 14.8091 21.2276 9.99512 20.1249 7.31201C19.5437 5.89771 18.3334 4.90397 16.9309 4.59881L17.2498 3.1331ZM12 4.50767C13.639 3.15871 15.5323 2.75939 17.2498 3.1331C19.1387 3.5441 20.7455 4.87608 21.5123 6.74181C23.0803 10.5571 21.0822 16.1396 12.3673 20.9065C12.1392 21.0312 11.8608 21.0312 11.6329 20.9065C2.91779 16.1396 0.919734 10.5572 2.48768 6.74183C3.25442 4.87609 4.86126 3.5441 6.75011 3.13311C8.46761 2.75939 10.3609 3.15871 12 4.50767Z"
  })));
};

export { SvgHeartOutline as ReactComponent };
//# sourceMappingURL=heart--outline.svg.js.map
